<template>
  <div style="height: 600px;">
    <div style="height: 30px;width: 100%;background: #EFF3F3">
      <span style="font-size: 12px;margin-left: 20px;text-align: center;line-height: 30px;">请输入要查询的车辆信息
                              计费标准： 1 元/次</span>
    </div>
    <div class="checkDL">
      <Input v-model="carNum" placeholder="请输入车牌号" style="width: 200px;margin-left: 5px"/>
      <Select v-model="carCorlor" placeholder="车牌颜色" style="width: 200px;margin-left: 5px">
        <Option v-for="(item,index) in colorType" :value="item.value" :key="index">{{ item.label }}</Option>
      </Select>
      <Button status="primary" icon="ios-search" style="margin-left: 10px;border-radius: 5px;" @click="commit">搜索</Button>
    </div>

    <div style="height: 30px;width: 100%;background: #EFF3F3">
      <span style="font-size: 12px;margin-left: 20px;text-align: center;line-height: 30px;">查询结果</span>
    </div>
    <div class="resultFour">{{resultFour}}</div>
  </div>
</template>
<script>
  import {apiGet} from "../../utils/api";
  import {hideLoading, showLoading} from "@/utils/util";

  export default {
    name: 'checkDL',
    data() {
      return {
        carNum: '',
        carCorlor: '',
        resultFour: '',
        colorType: [
          {
            value: 2,
            label: "黄牌"
          },
          {
            value: 1,
            label: "蓝牌"
          }
        ],
      }
    },
    methods: {
      commit() {
        let self = this;
        //提示填写信息
        if (!this.carNum || !this.carCorlor) {
          this.$XModal.alert({
            message: '请输入完整信息！',
            status: "error",
          });
          return;
        }
        this.$XModal.confirm("请确认信息无误，确认后将付费查询").then((type) => {
          if (type === "confirm") {
            this.vQueryLicenseV2();
          }
        });
      },
      async vQueryLicenseV2() {
        let params = {
          method: 'vQueryLicenseV2',
          params: {
            vno: this.carNum,
            vco: this.carCorlor
          }
        }
        showLoading();
        // let res = {
        //   "result":
        //     {
        //       "vclLng": "8000",
        //       "boxWdt": "2300",
        //       "vehicleAxis": "4",
        //       "prdCdNm": "SDZ3317ZZ4667E1",
        //       "boxHgt": "0",
        //       "drvLicDt": "1548000001000",
        //       "city": "370100",
        //       "country": "章丘市",
        //       "vclWnrPhn": "178***0001",
        //       "vclWnrNm": "董**",
        //       "vclHgt": "0",
        //       "vclTon": "31000",
        //       "vclTpNm": "重型自卸货车",
        //       "cmpNm": "章丘***司",
        //       "vin": "LFWRMU9J900004533",
        //       "boxLng": "8000",
        //       "province": "370000",
        //       "ldTn": "15370",
        //       "vclWdt": "2300",
        //       "ctyCode": "370181",
        //       "vbrndCdNm": "圣岳",
        //       "drvLicVdy": "null"
        //     },
        //   "status": 1001
        // }
        let res = await apiGet("api/order/track/", params.method, params.params);
        hideLoading();
        if (res && res.status === 1) {
          let resData = JSON.parse(res.data)
          if (resData.status === 1001) {
            let data = resData.result;
            let vclWnrNm = data.vclWnrNm ? data.vclWnrNm : '';//联系人
            let vclWnrPhn = data.vclWnrPhn ? data.vclWnrPhn : '';//联系人手机
            let province = data.province ? data.province : '';//省编码
            let city = data.city ? data.city : '';//市编码
            let country = data.country ? data.country : '';//县
            let ctyCode = data.ctyCode ? data.ctyCode : '';//县编码
            let vclTpNm = data.vclTpNm ? data.vclTpNm : '';//车辆类型
            let vbrndCdNm = data.vbrndCdNm ? data.vbrndCdNm : '';//车辆品牌
            let cmpNm = data.cmpNm ? data.cmpNm : '';//车主/业户
            let vin = data.vin ? data.vin : '';//车辆识别代码/车架号
            let vclTon = data.vclTon ? data.vclTon : '';//总质量/准牵引总质量
            let ldTn = data.ldTn ? data.ldTn : '';//核定载重量
            let vclLng = data.vclLng ? data.vclLng : '';//外廓尺寸-长(mm)
            let vclWdt = data.vclWdt ? data.vclWdt : '';//外廓尺寸-宽(mm)
            let vclHgt = data.vclHgt ? data.vclHgt : '';//外廓尺寸-高(mm)
            let boxLng = data.boxLng ? data.boxLng : '';//内廓尺寸-长(mm)
            let boxWdt = data.boxWdt ? data.boxWdt : '';//内廓尺寸-宽(mm)
            let boxHgt = data.boxHgt ? data.boxHgt : '';//内廓尺寸-高(mm)
            let drvLicDt = data.drvLicDt ? data.drvLicDt : '';//行驶证发证日期
            let drvLicVdy = data.drvLicVdy ? data.drvLicVdy : '';//行驶证有效期 UTC
            let vehicleAxis = data.vehicleAxis ? data.vehicleAxis : '';//车轴数
            this.resultFour = "联系人：" + vclWnrNm + '\n联系人手机：' + vclWnrPhn +
              '\n省编码：' + province + '\t\t市编码：' + city + '\t\t县:' + country + '\t\t县编码:' + ctyCode +
              '\n车辆类型:' + vclTpNm + '\t\t车辆品牌:' + vbrndCdNm +
              '\n车主/业户:' + cmpNm + '\t\t车辆识别代码/车架号:' + vin +
              '\n总质量/准牵引总质量:' + vclTon + '\t\t核定载重量:' + ldTn +
              '\n外廓尺寸-长(mm):' + vclLng + '\t\t外廓尺寸-宽(mm):' + vclWdt + '\t\t外廓尺寸-高(mm):' + vclHgt +
              '\n内廓尺寸-长(mm):' + boxLng + '\t\t内廓尺寸-宽(mm):' + boxWdt + '\t\t内廓尺寸-高(mm):' + boxHgt +
              '\n行驶证发证日期:' + drvLicDt + '\t\t行驶证有效期 UTC:' + drvLicVdy + '\t\t车轴数:' + vehicleAxis;
          } else if (res.status === 1006) {
            this.resultFour = "无结果";
          } else {
            this.resultFour = "查询错误";
          }
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : '接口异常',
            status: "error",
          });
        }
      },
    }
  }
</script>
<style scoped>
  .checkDL {
    height: 40%;
    width: 100%;
    display: flex;
    align-items: center;
    margin-left: 80px;
  }

  .resultFour {
    /*height: 20%;*/
    margin-top: 10px;
    line-height: 30px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-left: 80px;
    white-space: pre;
  }
</style>